<template>
    <div class="modal d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Have a Suggestion?</h5>
                </div>
                <div class="modal-body">

                    <div v-if="isSent" class="alert alert-success">Suggestion sent, we will be in touch shortly.</div>
                    <div v-if="hasError" class="alert alert-danger">
                        Sorry, we are currently unable to send you suggestion.<br/>
                        We want to hear from you please try again or contact support.
                    </div>

                    <form>
                        <div class="form-group">
                            <textarea class="form-control" rows="4"
                                      :class="{'input': true, 'is-invalid': $v.form.message.$error  }"
                                      v-model.trim="form.message" @input="delayTouch($v.form.message)"
                                      placeholder="Have feedback or a suggestion let us know"></textarea>

                            <span v-if="$v.form.message.$error" class="invalid-feedback form-text text-danger">
                                <span v-if="!$v.form.message.required">Let us know what you think</span>
                            </span>
                        </div>
                    </form>
                </div>
                <div class="modal-footer pt-0">
                    <button @click.prevent="closeModal" type="button" class="btn btn-link mt-0" data-dismiss="modal">
                        Cancel
                    </button>
                    <button @click.prevent="submitSuggestion" type="button" class="btn btn-primary mt-0">
                        <span v-show="isLoading">
                            <i class="fas fa-spinner fa-pulse"></i>
                        </span>
                        <span v-show="!isLoading">Send</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import contact from '../../command/contact'
import {required} from 'vuelidate/lib/validators'

const touchMap = new WeakMap()

export default {
    data() {
        return {

            form: {
                message: ''
            },

            isLoading: false,
            isSent: false,

            hasError: false,
            errorCode: null,
            errorMsg: null

        }
    },
    computed: {},
    validations: {
        form: {
            message: {
                required
            }
        }
    },
    methods: {

        delayTouch($v) {
            this.errorCode = null
            this.errorMsg = null
            this.hasError = false

            $v.$reset()
            if (touchMap.has($v)) {
                clearTimeout(touchMap.get($v))
            }
            touchMap.set($v, setTimeout($v.$touch, 1000))
        },

        submitSuggestion() {
            let self = this

            if (self.$v.$invalid) {
                self.$v.$touch()
                return
            }

            self.isLoading = true
            self.isSent = false
            self.hasError = false

            contact.suggestion({body: self.form.message}).then(resp => {
                self.isLoading = false
                self.isSent = true

                setTimeout(function() {
                    self.closeModal()
                }, 2500)
            }).catch(err => {
                self.isLoading = false
                self.hasError = true
                self.errorCode = err.statusCode
            })
        },

        closeModal() {
            this.$emit('close')
        }
    }
}
</script>
